<template>
  <div>
    <slot name="activate" :openDialog="openDialog" />

    <v-dialog v-model="dialog" width="430" persistent>
      <v-card rounded="xl">
        <v-card-title class="flex-column gap-12 justify-center pt-8 pb-8">
          <v-icon color="#FED7B3" size="85">mdi-alert-circle-outline</v-icon>
          <section class="font-24 font-w-500">{{ title }}</section>
          <section class="font-18 font-w-400">{{ subTitle }}</section>
        </v-card-title>
        <v-card-text class="px-6">
          <v-form ref="formEdit">
            <v-row>
              <v-col cols="12">
                <section class="mb-2">
                  <span>{{ label }}</span>
                  <span class="red--text">*</span>
                </section>
                <v-textarea
                  v-model="note"
                  :rules="[(v) => !!v || 'ระบุเหตุผล']"
                  placeholder="ระบุเหตุผล"
                  color="#a9182a"
                  outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions class="gap-16 justify-center px-6 pb-6">
          <button class="btn--cancel" @click="dialog = false">ยกเลิก</button>
          <button class="btn--confirm" @click="submit">ยืนยัน</button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
      note: '',
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
    submit() {
      if (this.$refs.formEdit.validate()) {
        this.$emit('confirm', this.note)
        this.dialog = false
        this.note = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.btn {
  width: 140px;
  height: 45px;
  border-radius: 8px;
  text-align: center;
  &--cancel {
    @extend .btn;
    border: 1px solid #a9182a;
    background: #fff;
    color: #a9182a;
  }
  &--confirm {
    @extend .btn;
    border: 1px solid #a9182a;
    background: #a9182a;
    color: #fff;
  }
}
</style>
